(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  /** Full-screen predictive search: debounced fetch against Shopify's suggest API. */
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-search-input]');
      this.resultsEl = this.querySelector('[data-search-results]');
      this.rootUrl = this.dataset.rootUrl || '/';
      this.searchUrl = this.dataset.searchUrl || '/search';
      this.debounceTimer = null;
      this.controller = null;

      document.querySelectorAll('[data-open-search]').forEach((btn) =>
        btn.addEventListener('click', () => this.open())
      );
      this.querySelectorAll('[data-close-search]').forEach((btn) =>
        btn.addEventListener('click', () => this.close())
      );
      this.input?.addEventListener('input', () => this.#onInput());
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
        if (event.key === '/' && document.activeElement?.tagName !== 'INPUT' && !this.isOpen) {
          event.preventDefault();
          this.open();
        }
      });
    }

    get isOpen() {
      return this.getAttribute('data-open') === 'true';
    }

    open() {
      this.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      window.requestAnimationFrame(() => this.input?.focus());
    }

    close() {
      this.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
    }

    #onInput() {
      clearTimeout(this.debounceTimer);
      const term = this.input.value.trim();

      if (term.length < 2) {
        this.resultsEl.innerHTML = '';
        return;
      }

      this.debounceTimer = setTimeout(() => this.#fetchResults(term), 250);
    }

    async #fetchResults(term) {
      this.controller?.abort();
      this.controller = new AbortController();

      try {
        const url = `${this.rootUrl}search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const response = await fetch(url, { signal: this.controller.signal });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const data = await response.json();
        this.#renderResults(term, data?.resources?.results?.products || []);
      } catch (error) {
        if (error.name !== 'AbortError') console.error('[PredictiveSearch]', error);
      }
    }

    #renderResults(term, products) {
      if (products.length === 0) {
        this.resultsEl.innerHTML = `<p class="search-overlay__empty">No results for &ldquo;${this.#escape(term)}&rdquo;</p>`;
        return;
      }

      const items = products
        .map(
          (product) => `
            <a href="${product.url}" class="search-overlay__product">
              <span class="search-overlay__product-media">
                ${product.featured_image ? `<img src="${product.featured_image.url}" alt="" width="80" height="100" loading="lazy">` : ''}
              </span>
              <span>
                <span class="search-overlay__product-title">${this.#escape(product.title)}</span>
                <span class="search-overlay__product-price">${product.price ?? ''}</span>
              </span>
            </a>`
        )
        .join('');

      this.resultsEl.innerHTML = `
        <p class="search-overlay__section-label">Products</p>
        <div class="search-overlay__product-list">${items}</div>
        <a href="${this.searchUrl}?q=${encodeURIComponent(term)}" class="button--text search-overlay__view-all">
          View all results for &ldquo;${this.#escape(term)}&rdquo;
        </a>
      `;
    }

    #escape(value) {
      const div = document.createElement('div');
      div.textContent = value;
      return div.innerHTML;
    }
  }

  customElements.define('predictive-search', PredictiveSearch);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /** Filter drawer: a focused, full-height panel on every screen size. */
  class FilterDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-filter-panel]');
      this.overlay = this.querySelector('.collection__filters-overlay');

      this.querySelectorAll('[data-open-filters]').forEach((btn) =>
        btn.addEventListener('click', () => this.open())
      );
      this.querySelectorAll('[data-close-filters]').forEach((btn) =>
        btn.addEventListener('click', () => this.close())
      );
      this.querySelectorAll('[data-collection-switch]').forEach((select) =>
        select.addEventListener('change', () => {
          if (select.value) window.location.assign(select.value);
        })
      );
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });
    }

    open() {
      this.setAttribute('data-open', 'true');
      this.panel?.setAttribute('data-open', 'true');
      this.panel?.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    close() {
      this.removeAttribute('data-open');
      this.panel?.removeAttribute('data-open');
      this.panel?.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  customElements.define('filter-drawer', FilterDrawer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const gallery = document.querySelector('.product__gallery');
    if (!gallery) return;

    const mainImage = document.querySelector('[data-product-main-image]');
    const stickyImage = document.querySelector('[data-sticky-image]');
    const setMainMedia = (media) => {
      if (!media || !mainImage) return;
      mainImage.src = media.src;
      if (media.srcset) mainImage.srcset = media.srcset;
      mainImage.alt = media.alt || '';
      if (stickyImage) stickyImage.src = media.src;
      gallery.querySelectorAll('[data-thumbnail]').forEach((thumb) => {
        const isActive = String(thumb.dataset.mediaId) === String(media.mediaId);
        thumb.classList.toggle('is-active', isActive);
        if (isActive) thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      });
    };
    gallery.querySelectorAll('[data-thumbnail]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        setMainMedia({
          mediaId: thumb.dataset.mediaId,
          src: thumb.dataset.fullSrc,
          srcset: thumb.dataset.fullSrcset,
          alt: thumb.dataset.alt,
        });
      });
    });

    const qtyInput = document.querySelector('[data-qty-input]');
    document.querySelector('[data-qty-decrease]')?.addEventListener('click', () => {
      qtyInput.value = Math.max(1, Number(qtyInput.value) - 1);
    });
    document.querySelector('[data-qty-increase]')?.addEventListener('click', () => {
      qtyInput.value = Number(qtyInput.value) + 1;
    });

    /** Show the sticky mobile bar only once the real add-to-cart button scrolls out of view. */
    const stickyBar = document.querySelector('[data-sticky-atc]');
    const mainAddButton = document.querySelector('.product__add-to-cart');
    if (stickyBar && mainAddButton && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        ([entry]) => stickyBar.setAttribute('data-visible', String(!entry.isIntersecting)),
        { rootMargin: '0px 0px -10% 0px' }
      );
      observer.observe(mainAddButton);
    }

    /**
     * Resolve the currently selected option-N radios to a real variant
     * and sync the hidden id input, price, and add-to-cart state.
     */
    const safeParse = (el, fallback) => {
      if (!el) return fallback;
      try {
        return JSON.parse(el.textContent);
      } catch (error) {
        console.error('[Product] Could not parse embedded JSON', error);
        return fallback;
      }
    };
    const variants = safeParse(document.querySelector('[data-product-variants]'), []);
    const variantMedia = safeParse(document.querySelector('[data-variant-media]'), {});
    const idInput = document.querySelector('[data-variant-id]');
    const priceWrapper = document.querySelector('[data-price-wrapper]');
    const addButton = document.querySelector('.product__add-to-cart');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const stickyAddButton = document.querySelector('[data-sticky-add-button]');
    const optionInputs = document.querySelectorAll('.product__option-values input[type="radio"]');

    const formatMoney = (cents) => `$${(cents / 100).toFixed(2)}`;

    const syncVariant = () => {
      if (!variants.length) return;

      const selected = [...document.querySelectorAll('.product__option')].map((fieldset) => {
        const checked = fieldset.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });

      const match = variants.find((variant) =>
        [variant.option1, variant.option2, variant.option3]
          .slice(0, selected.length)
          .every((value, index) => value === selected[index])
      );

      if (!match) return;

      if (idInput) idInput.value = match.id;

      if (priceWrapper) {
        let html = formatMoney(match.price);
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += ` <s class="product__compare-price">${formatMoney(match.compare_at_price)}</s>`;
        }
        priceWrapper.innerHTML = html;
      }
      if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);

      if (addButton) {
        addButton.disabled = !match.available;
        addButton.textContent = match.available ? addButton.dataset.availableLabel : addButton.dataset.soldOutLabel;
      }
      if (stickyAddButton) {
        stickyAddButton.disabled = !match.available;
        stickyAddButton.textContent = match.available ? stickyAddButton.dataset.availableLabel : stickyAddButton.dataset.soldOutLabel;
      }

      const selectedMedia = variantMedia[String(match.id)];
      if (selectedMedia) setMainMedia(selectedMedia);

      if (window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url);
      }
    };

    optionInputs.forEach((input) => input.addEventListener('change', syncVariant));
  })();

  } catch(e) { console.error(e); }
})();
})();
